<!--<p class="fw-semibold text-primary mt-4 mb-2">View by Project Type</p>-->
<form id="multi-project-type-selector-form" class="mt-4">
  <label for="multiProjectSelector" id="multi-project-type-selector-heading" class=" fw-semibold text-primary mb-2"
  >View By Project Types</label>

  <ng-select
    [items]="groupedProjectTypes"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [closeOnSelect]="false"
    [clearSearchOnAdd]="true"
    (blur)="onBlur()"
    (change)="onSelectionChange($event)"
  >
    <ng-template ng-option-tmp let-item="item">
      <input
        *ngIf="item.type === 'option'"
        type="checkbox"
        [checked]="formControl.value?.includes(item.id)"
      />
      {{ item.name }}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngIf="allSelected">
        <span class="ng-value-label">All Branches</span>
        <span class="ng-value-icon right" (click)="clearAll()" aria-hidden="true"
        >×</span
        >
      </div>

      <ng-container *ngIf="!allSelected">
        @for (item of items; track item) {
          <div class="ng-value">
            <span class="ng-value-label">{{ item.name }}</span>
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
            >×</span
            >
          </div>
        }
      </ng-container>
    </ng-template>
  </ng-select>

  <div *ngIf="formControl.errors?.['minlength']" class="error">
    At least one geozone is required.
  </div>
</form>
